import PopoverTable from './popoverTable';

export default PopoverTable;
